import {Faq} from '../model/faq';

export const SECOND_FAQ_LABELKEY = 'eos-tv-shop-ii.faqs.second-faq';
export const FOURTH_FAQ_LABELKEY = 'eos-tv-shop-ii.faqs.fourth-faq';

export const standaloneNetflixFaqsConstants: Faq[] = [
  {
    title: 'eos-tv-shop-ii.faqs.first-faq.title',
    description: 'eos-tv-shop-ii.faqs.first-faq.description'
  },
  {
    title: SECOND_FAQ_LABELKEY + '.title',
    description: SECOND_FAQ_LABELKEY + '.description'
  },
  {
    title: 'eos-tv-shop-ii.faqs.third-faq.title',
    description: 'eos-tv-shop-ii.faqs.third-faq.description'
  },
  {
    title: FOURTH_FAQ_LABELKEY + '.title',
    description: FOURTH_FAQ_LABELKEY + '.description'
  }
];

export const standaloneDisneyPlusFaqsConstants: Faq[] = [
  {
    title: 'eos-tv-shop-ii.disney.faqs.first-faq.title',
    description: 'eos-tv-shop-ii.disney.faqs.first-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.disney.faqs.second-faq.title',
    description: 'eos-tv-shop-ii.disney.faqs.second-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.disney.faqs.third-faq.title',
    description: 'eos-tv-shop-ii.disney.faqs.third-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.disney.faqs.fourth-faq.title',
    description: 'eos-tv-shop-ii.disney.faqs.fourth-faq.description'
  }
];

export const standaloneStreamzFaqsConstants: Faq[] = [
  {
    title: 'eos-tv-shop-ii.streamz.faqs.first-faq.title',
    description: 'eos-tv-shop-ii.streamz.faqs.first-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz.faqs.second-faq.title',
    description: 'eos-tv-shop-ii.streamz.faqs.second-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz.faqs.third-faq.title',
    description: 'eos-tv-shop-ii.streamz.faqs.third-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz.faqs.fourth-faq.title',
    description: 'eos-tv-shop-ii.streamz.faqs.fourth-faq.description'
  }
];

export const standaloneStreamzPlusFaqsConstants: Faq[] = [
  {
    title: 'eos-tv-shop-ii.streamz-plus.faqs.first-faq.title',
    description: 'eos-tv-shop-ii.streamz-plus.faqs.first-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-plus.faqs.second-faq.title',
    description: 'eos-tv-shop-ii.streamz-plus.faqs.second-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-plus.faqs.third-faq.title',
    description: 'eos-tv-shop-ii.streamz-plus.faqs.third-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-plus.faqs.fourth-faq.title',
    description: 'eos-tv-shop-ii.streamz-plus.faqs.fourth-faq.description'
  }
];

export const standaloneStreamzBasicFaqsConstants: Faq[] = [
  {
    title: 'eos-tv-shop-ii.streamz-basic.faqs.first-faq.title',
    description: 'eos-tv-shop-ii.streamz-basic.faqs.first-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-basic.faqs.second-faq.title',
    description: 'eos-tv-shop-ii.streamz-basic.faqs.second-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-basic.faqs.third-faq.title',
    description: 'eos-tv-shop-ii.streamz-basic.faqs.third-faq.description'
  },
  {
    title: 'eos-tv-shop-ii.streamz-basic.faqs.fourth-faq.title',
    description: 'eos-tv-shop-ii.streamz-basic.faqs.fourth-faq.description'
  }
];
